import { Link } from "react-router-dom";
import ThomLogo from "@/components/ThomLogo";

/**
 * Continental corporate footer (parent brand). Distinct from the country
 * footer — it does not list a country-specific marketplace or service list.
 */
export default function AfricaFooter() {
  return (
    <footer className="mt-24 bg-[#0A0A0A] text-white/80 border-t border-white/10" data-testid="africa-footer">
      <div className="max-w-[1500px] mx-auto px-6 py-14 grid md:grid-cols-[1.4fr_auto_auto_auto] gap-12 items-start">
        <div className="max-w-[600px]">
          <ThomLogo size={40} variant="onDark" showTagline />
          <p className="mt-6 text-[12.5px] leading-[1.8] text-white/65" data-testid="africa-footer-positioning">
            THOM Verify™ is Africa's Independent Verification and Transaction Assurance Company,
            providing independent verification, evidence collection, due diligence and documented
            findings that help individuals, businesses, financial institutions and governments
            make informed decisions across Africa.
          </p>
        </div>

        <FooterCol title="Platform">
          <FooterLink to="/africa/services">Verification Services</FooterLink>
          <FooterLink to="/africa/industries">Industries</FooterLink>
          <FooterLink to="/africa/trust-infrastructure">Trust Infrastructure</FooterLink>
          <FooterLink to="/africa/countries">Countries</FooterLink>
        </FooterCol>
        <FooterCol title="Enterprise">
          <FooterLink to="/africa/enterprise">Enterprise Solutions</FooterLink>
          <FooterLink to="/network">Trust Network</FooterLink>
          <FooterLink to="/africa/enterprise#apis">Enterprise APIs</FooterLink>
        </FooterCol>
        <FooterCol title="Trust">
          <FooterLink to="/verify">Verify a Certificate</FooterLink>
          <FooterLink to="/track-verification">Track a Request</FooterLink>
          <FooterLink to="/trust-centre">Trust Centre</FooterLink>
          <FooterLink to="/passport/vehicle/">Digital Asset Passport</FooterLink>
          <FooterLink to="/network/register">Become a partner</FooterLink>
        </FooterCol>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 py-6 text-[11.5px] text-white/55 leading-[1.75] max-w-[960px]" data-testid="africa-footer-philosophy">
          <b className="text-white/80">Service Philosophy.</b>{" "}
          THOM Verify complements — not replaces — the roles of statutory authorities, regulators,
          law-enforcement agencies, legal advisers, insurers, engineers acting in a certification
          capacity and other professionals whose approvals, certifications or decisions are required
          by law.
        </div>
        <div className="max-w-[1500px] mx-auto px-6 pb-6 text-[11px] text-white/45 leading-[1.75] max-w-[960px]">
          THOM Verify™ provides independent findings based on information available at the time of
          verification and applicable data sources. Final regulatory decisions remain the
          responsibility of the appropriate authorities.
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] text-white/50">
          <div>© {new Date().getFullYear()} THOM Verify™ Africa · Africa's Independent Verification and Transaction Assurance Company.</div>
          <div className="mono uppercase tracking-widest">Securing Assets · Building Trust</div>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, children }) => (
  <div>
    <div className="mono text-[10px] uppercase tracking-widest text-white/40 mb-3">{title}</div>
    <ul className="space-y-2">{children}</ul>
  </div>
);

const FooterLink = ({ to, children }) => (
  <li><Link to={to} className="text-[13px] hover:text-white transition-colors">{children}</Link></li>
);
